import React, {useState, useMemo} from "react";
import "./RightSidebar.less";
import {SIDEBAR_BANNERS} from "../../default_informations/sidebar_banners";
import {API_KEY} from "../../default_informations/api_key";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, { Autoplay } from 'swiper';
import 'swiper/swiper-bundle.css';
import SidebarBanner from "./SidebarBanner";
import SidebarSliderItem from "./SidebarSliderItem";
import Loader from "../Loader";

SwiperCore.use([Autoplay]);

function RightSidebar() {
    const sidebarBanners = SIDEBAR_BANNERS;
    const apiKey = API_KEY;
    const [topMatches, setTopMatches] = useState([]);

    useMemo(() => {
        fetch(`https://api.opendota.com/api/proMatches?api_key=${apiKey}`)
            .then(response => response.json())
            .then(result => {
                let match_count = 0;
                let matches_arr = result.filter(item => {

                    let start_date = item.start_time;
                    let start_match = new Date(start_date * 1000);

                    let year = start_match.getFullYear();
                    let month = start_match.getMonth() + 1;
                    if (month < 10) month = `0${month}`;
                    let date = start_match.getDate();
                    if (date < 10) date = `0${date}`;
                    let hours = start_match.getHours();
                    if (hours < 10) hours = `0${hours}`;
                    let minutes = start_match.getMinutes();
                    if (minutes < 10) minutes = `0${minutes}`;

                    let match_date = `${date}.${month}.${year}`;

                    let now_year = new Date().getFullYear();
                    let now_month = new Date().getMonth() + 1;
                    if (now_month < 10) now_month = `0${now_month}`;
                    let now_date = new Date().getDate();
                    if (now_date < 10) now_date = `0${now_date}`;

                    let date_now = `${now_date}.${now_month}.${now_year}`;

                    if (Boolean(item.dire_team_id) && Boolean(item.radiant_team_id && Boolean(item.dire_name) && Boolean(item.radiant_name)) && (match_count < 10) && (match_date === date_now)) {
                        match_count++;
                        return item;
                    }
                    return null;
                });
                if (!matches_arr.length) {
                    let tomorrow_matches = result.filter(item => {
                        if (Boolean(item.dire_team_id) && Boolean(item.radiant_team_id && Boolean(item.dire_name) && Boolean(item.radiant_name)) && (match_count < 10)) {
                            match_count++;
                            return item;
                        }
                        return null;
                    });
                    setTopMatches(tomorrow_matches);
                } else {
                    setTopMatches(matches_arr);
                }
            })
    }, [apiKey]);

    return (
        <aside className="sidebar gg-right-sidebar">
            <p className="top_matches">Топ события дня</p>
            <div className="sidebar-tabs">
                <ul className="tab-nav">
                    <li className="nav-item active">
                        <a href="#dota_tab">
                            <svg width="16" height="16" viewBox="0 0 80 80">
                                <use xlinkHref="#esports_dota_2_81226" />
                            </svg>
                            <span>Dota 2</span>
                        </a>
                    </li>
                </ul>
                <div className="tabs">{
                    topMatches.length ? (
                        <div id="dota_tab" className="tab active">
                            <Swiper
                                spaceBetween={0}
                                slidesPerView={1}
                                loop={true}
                                autoplay={{
                                    delay: 3500,
                                    disableOnInteraction: false
                                }}
                            >
                                {
                                    topMatches.map(item => (
                                        <SwiperSlide key={item.match_id}>
                                            <SidebarSliderItem match={item} />
                                        </SwiperSlide>
                                    ))
                                }
                            </Swiper>
                        </div>
                    ) : (
                        <Loader/>
                    )
                }</div>
            </div>
            <div className="gg-slots popular">{
                sidebarBanners.map(item => <SidebarBanner key={item.id} banner={item}/>)
            }</div>
        </aside>
    )
}

export default RightSidebar;